export const loadingExclude = [
    '/absi/save',
    '/checklist/sign',
    '/checklist/save',
    '/beamlineStatus',
    '/ProcedureReports/',
    '/Restriction/CheckByLocation',
    '/RSSFunctionalTest/Checklist',
    '/RSF/ParseNotificationConditions',
    '/Resources',
    '/FormProperties',
    '/KEnable/Sign',
    '/ChecklistBuilder/SaveOrder',
    // KE task persistence and its section refresh run in the background while users continue checking items.
    '/KEnable/Save/',
    '/KEnable/BySection/',
    // Workflow Assistant requests should not block the rest of the ASCC interface.
    '/WorkFlowTask/PendingForMe',
    '/WorkflowAssistant/Interpret',
    // Hub token exchange runs behind every SignalR connect and reconnect; it must not flash the loading overlay.
    '/Authentication/HubToken'
]
